export default __webpack_public_path__ + "static/media/galletas-dino.5351cbec.jpg";